import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

const MILESTONE_EVENTS = [3, 5, 10];
const CELEBRATED_KEY_PREFIX = 'celebrated_monthly_milestone_';

export const useStreakMilestone = (monthlyEventCount: number | null | undefined, userId: string | undefined) => {
  const [celebrationMilestone, setCelebrationMilestone] = useState<number | null>(null);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!monthlyEventCount || !userId) return;

    // Get current month key for tracking
    const currentMonth = new Date().toISOString().slice(0, 7); // YYYY-MM format

    // Check if we hit a milestone
    const milestone = MILESTONE_EVENTS.find(m => m === monthlyEventCount);
    
    if (milestone) {
      const celebratedKey = `${CELEBRATED_KEY_PREFIX}${userId}_${currentMonth}_${milestone}`;
      const alreadyCelebrated = localStorage.getItem(celebratedKey);

      if (!alreadyCelebrated) {
        // Mark as celebrated
        localStorage.setItem(celebratedKey, 'true');
        
        // Trigger celebration
        setCelebrationMilestone(milestone);

        // Create achievement notification
        import('@/integrations/supabase/client').then(({ supabase }) => {
          supabase.from('user_notifications').insert({
            user_id: userId,
            type: 'achievement',
            message: `Congratulations! You've attended ${milestone} events this month! 🎉`,
            reference_id: null,
          }).then(() => {
            queryClient.invalidateQueries({ queryKey: ['notifications'] });
          });
        });
      }
    }
  }, [monthlyEventCount, userId, queryClient]);

  const closeCelebration = () => {
    setCelebrationMilestone(null);
  };

  return {
    celebrationMilestone,
    closeCelebration,
  };
};
